














import Vue from 'vue'

import AppForm from '@/components/app/AppForm.vue'

export default Vue.extend({
  name: "admin-billing-page",
  components: { AppForm },
  props: {
    resource: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      billingFields: [
        {
          dataType: "string",
          display: "field",
          fieldTag: "input",
          fieldType: "text",
          key: "name",
          label: "Billing Name",
          order: 0
        },
        {
          dataType: "map",
          display: "multifield",
          key: "address",
          label: "Billing Address",
          order: 1
        },
        {
          dataType: "number",
          defaultValue: 0,
          display: "field",
          fieldTag: "select",
          fieldType: "option",
          key: "paymentMethods",
          label: "Payment Method",
          options: [
            {
              label: "Manual Payment",
              value: 0
            },
            {
              label: "Card Subscription",
              value: 1
            },
            {
              label: "Direct Debit",
              value: 2
            }
          ],
          order: 2
        }
      ]
    }
  },

  computed: {
    
  },

  methods: {
    
  },

  filters: {
    
  },

  created() {

  },
  mounted() {

  },
  updated() {
    
  }
})
